



























import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import MainTabbar from "../general/MainTabbar.vue";

import EventsOverview from "./EventsOverview.vue";
import EventsCalendar from "./EventsCalendar.vue";
import EventsParticipants from "./EventsParticipants.vue";
import EventsAll from "./EventsAll.vue";
import EventsIndividualBookings from "./EventsIndividualBookings.vue";
import EventsPayments from "./EventsPayments.vue";
import EventsEvents from "./EventsEvents.vue";
import EventsTemplates from "./EventsTemplates.vue";

import SettingsJson from "../../shared/SettingsJson";
import SettingsNotificationsJson from "../../shared/SettingsNotificationsJson";
import UserJson from "../../shared/UserJson";
import ModulesJson, { checkModuleIsActivated } from "../../shared/ModulesJson";
import { checkPermission } from "../../shared/UserPermission";
import { UserPermissionType } from "../../shared/UserPermissionType";

export default Vue.extend({
  name: "Events",
  components: {
    MainTabbar,
    EventsCalendar,
    EventsParticipants,
    EventsOverview,
    EventsAll,
    EventsIndividualBookings,
    EventsPayments,
    EventsEvents,
    EventsTemplates,
  },
  props: {
    restClient: RestClient,
    loginUser: Object as PropType<UserJson>,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    settingsNotifications: Object as PropType<SettingsNotificationsJson>,
    appFrameClickedButton: Object,
  },
  data() {
    return {
      currentMainTabbarTab: "",
      checkModuleIsActivated: checkModuleIsActivated,
      checkPermission: checkPermission,
      eventIdToShow: null as number | null,
    };
  },
  created() {},
  methods: {
    changeMainTabbarTab: function (tab: string, id: number | null = null) {
      this.currentMainTabbarTab = tab;
      this.eventIdToShow = id;
    },
  },
  computed: {
    mainTabbarItems(): ModulesJson[] {
      let vue = this;

      return [
        {
          title: "Übersicht",
          linkedComponent: "EventsOverview",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleEvents),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleEvents),
        },
        {
          title: "Kalender",
          linkedComponent: "EventsCalendar",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleEvents),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleEvents),
        },
        {
          title: "Teilnehmende",
          linkedComponent: "EventsParticipants",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleEvents),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleEvents),
        },
        {
          title: "Alle Plätze",
          linkedComponent: "EventsAll",
          permissionRank: 2,
          userPermission: null,
          isDisabled: true,
          isDisplayed: false,
        },
        {
          title: "Individuell",
          linkedComponent: "EventsIndividualBookings",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleEvents),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleEvents),
        },
        {
          title: "Zahlungen",
          linkedComponent: "EventsPayments",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.modulePayments),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.modulePayments),
        },
        {
          title: "Veranstaltungen",
          linkedComponent: "EventsEvents",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleEvents),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleEvents),
        },
        {
          title: "Vorlagen",
          linkedComponent: "EventsTemplates",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleEvents),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleEvents),
        },
      ] as ModulesJson[];
    },
  },
});
